export default {
  path: '/welcome',
  name: 'Welcome',
  component : () => import('@/views/Welcome'),
  // children: [
  //   {
  //     path: '/welcome',
  //     name: 'Welcome',
  //     component : () => import('@/views/Welcome')
  //   }
  // ]
};